export default function Loader() {
    return (<div className="spinner-border spinner-border-sm ms-1"></div>);
}